import { create } from "zustand";
import { devtools, persist } from "zustand/middleware";

import type { AuthState, PermissionKey, User } from "../types";

interface AuthActions {
  setAuthenticated: (user: User, permissions: PermissionKey[]) => void;
  setUnauthenticated: () => void;
  setHydrated: (value: boolean) => void;
  logout: () => void;
}

export const useAuthStore = create<AuthState & AuthActions>()(
  devtools(
    persist(
      (set) => ({
        isAuthenticated: false,
        isHydrated: false,
        user: null,
        permissions: [],
        setAuthenticated: (user, permissions) => set({ isAuthenticated: true, user, permissions }),
        setUnauthenticated: () => set({ isAuthenticated: false, user: null, permissions: [] }),
        setHydrated: (value) => set({ isHydrated: value }),
        logout: () => set({ isAuthenticated: false, user: null, permissions: [] }),
      }),
      {
        name: "auth-store",
        partialize: (state) => ({ user: state.user, permissions: state.permissions, isAuthenticated: state.isAuthenticated }),
      },
    ),
  ),
);
